export default __webpack_public_path__ + "static/media/ScrollToTopButton.75185b2b.png";